<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>Iniciales</h3>
          <p>
            Configuración de las iniciales y sus características (tamaños,
            precios, fuente y alturas).
          </p>

          <!-- <h4>Características básicas</h4> -->
          <!-- Form -->
          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.success.show" variant="success">{{
              form.success.text
            }}</b-alert>
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <!-- <h4>Características</h4> -->

            <b-form-row class="mt-4">
              <b-col>
                <h4>Tamaños y precios</h4>

                <b-button size="sm" variant="outline-primary" @click="addSize"
                  >Nuevo tamaño</b-button
                >

                <b-form-row class="mt-4">
                  <b-col :cols="2"><label>Tamaño</label> </b-col>
                  <!-- <b-col :cols="2"><label>Centímetros</label> </b-col> -->
                  <b-col :cols="2"><label>Precio</label> </b-col>
                </b-form-row>
                <b-form-row
                  v-for="(v, i) in $v.form.sizes.$each.$iter"
                  :key="i"
                >
                  <b-col :cols="2"
                    ><b-form-group id="input-group-name" label-for="input-name">
                      <b-form-input
                        v-model="v.name.$model"
                        :state="validateStateSize(i, 'name')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <!-- <b-col :cols="2">
                    <b-form-group
                      id="input-group-centimeters"
                      label-for="input-centimeters"
                    >
                      <b-input-group append="cm">
                        <b-form-input
                          id="centimeters"
                          :value="v.centimeters.$model.replace('.', ',')"
                          @change="setDecimalSize(i, 'centimeters', $event)"
                          :state="validateStateSize(i, 'centimeters')"
                          aria-describedby="input-centimeters-feedback"
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </b-col> -->

                  <b-col :cols="2">
                    <b-form-group
                      id="input-group-price"
                      label-for="input-price"
                    >
                      <b-input-group append="€">
                        <b-form-input
                          id="price"
                          :value="v.price.$model.replace('.', ',')"
                          @change="setDecimalSize(i, 'price', $event)"
                          :state="validateStateSize(i, 'price')"
                          aria-describedby="input-price-feedback"
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="auto"
                    ><b-button
                      :disabled="form.sizes.length === 1"
                      @click="removeSize(i)"
                      variant="outline-danger"
                      ><b-icon icon="trash"></b-icon
                    ></b-button>
                  </b-col>
                </b-form-row>
              </b-col>
            </b-form-row>

            <b-form-row class="mt-4">
              <b-col>
                <h4>Tipografías</h4>

                <b-button
                  size="sm"
                  @click="addTypography"
                  variant="outline-primary"
                  >Nueva tipografía
                </b-button>

                <b-form-row class="mt-4">
                  <b-col :cols="2">Nombre </b-col>
                  <b-col :cols="2">Tipografía </b-col>
                  <b-col :cols="8" class="mb-3"> Tamaños y alturas </b-col>
                </b-form-row>
                <b-form-row
                  v-for="(v, i) in $v.form.typographies.$each.$iter"
                  :key="i"
                >
                  <b-col :cols="2">
                    <b-form-group
                      class="mt-4"
                      id="input-group-name"
                      label-for="input-name"
                    >
                      <b-input-group>
                        <b-form-input
                          :state="validateStateTypography(i, 'name')"
                          v-model="v.name.$model"
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col :cols="2">
                    <b-form-group
                      class="mt-4"
                      id="input-group-typography"
                      label-for="input-typography"
                    >
                      <b-input-group>
                        <b-form-select
                          id="input-category"
                          :state="validateStateTypography(i, 'typography')"
                          v-model="v.typography.$model"
                          :options="form.optionsTypographies"
                        ></b-form-select>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col :cols="8">
                    <!-- Reference -->

                    <b-form-row>
                      <b-col
                        :cols="2"
                        v-for="(b, j) in v.sizes.$each.$iter"
                        :key="j"
                      >
                        <b-form-group
                          id="input-group-subdomain"
                          label-for="input-subdomain"
                          class="mb-0"
                        >
                          <b-form-checkbox v-model="b.enabled.$model" switch>
                            {{ form.sizes[j].name }}
                          </b-form-checkbox>
                        </b-form-group>
                        <b-form-group
                          id="input-group-subdomain2"
                          label-for="input-subdomain2"
                        >
                          <b-input-group append="cm">
                            <b-form-input
                              :value="b.height.$model.replace('.', ',')"
                              @change="
                                setDecimalTypographySize(i, j, 'height', $event)
                              "
                              :state="
                                validateStateTypographySize(i, j, 'height')
                              "
                              :disabled="!b.enabled.$model"
                            ></b-form-input>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                      <b-col cols="auto" class="mt-4"
                        ><b-button
                          :disabled="form.typographies.length === 1"
                          @click="removeTypography(i)"
                          variant="outline-danger"
                          ><b-icon icon="trash"></b-icon
                        ></b-button>
                      </b-col>
                    </b-form-row>
                  </b-col>
                </b-form-row>
              </b-col>
            </b-form-row>

            <b-button class="mt-4" type="submit" variant="primary"
              >Guardar cambios</b-button
            >
          </b-form>
          <!-- /Form -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { required, decimal, minValue } from 'vuelidate/lib/validators';

import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import { helpers } from 'vuelidate/lib/validators';

import * as Sentry from '@sentry/browser';

import Multiselect from 'vue-multiselect';

import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

const isValidImage = (image) =>
  !helpers.req(image) || ['image/jpeg', 'image/png'].includes(image['type']);

export default {
  name: 'AdminInitialsEditScreen',
  props: {},
  components: { Multiselect, VueCropper },
  mixins: [validationMixin],
  validations() {
    let rules = {
      sizes: {
        $each: {
          name: {
            required,
          },
          price: {
            required,
            decimal,
            minValue: minValue(0.0),
          },
          // centimeters: {
          //   required,
          //   decimal,
          //   minValue: minValue(0.0),
          // },
        },
      },

      typographies: {
        $each: {
          name: {
            required,
          },
          typography: {
            required,
          },
          sizes: {
            $each: {
              enabled: {
                required,
              },
              height: {
                required,
                decimal,
                minValue: minValue(0.0),
              },
            },
          },
        },
      },
    };

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      sizes: [],
      typographies: [],

      error: {
        show: false,
        text: '',
      },
      success: {
        show: false,
        text: '',
      },
      optionsTypographies: [],
    };

    return {
      sharedState: store.state,
      languageCodes: store.getLanguageCodes().filter((x) => x == 'es'),
      languageNames: store.getLanguageNames(),
      form: form,
    };
  },
  created() {
    actions.getTypographiesUnpaginated().then((res) => {
      res.data.results.map((y) => {
        this.form.optionsTypographies.push({
          text: y.reference,
          value: y.reference,
        });
      });
    });

    actions.getInitials().then((x) => {
      if (x.data.count === 0) {
        store.setOverlayShow(false);

        this.addSize();
        this.addTypography();
      } else {
        const data = x.data.results[0];

        this.form.sizes = data.sizes;
        this.form.typographies = data.typographies;
      }

      store.setOverlayShow(false);
    });
  },
  methods: {
    addSize() {
      this.form.sizes.push({ name: '', price: '0.0' });

      this.form.typographies.map((typo) => {
        typo.sizes.push({
          enabled: true,
          height: '0.0',
        });
      });
    },
    addTypography() {
      let sizes = [];

      this.form.sizes.forEach((element) => {
        sizes.push({
          enabled: true,
          height: '0.0',
        });
      });

      this.form.typographies.push({ name: '', typography: '', sizes: sizes });
    },
    removeSize(i) {
      this.form.sizes.splice(i, 1);
      this.form.typographies.map((typography) => {
        typography.sizes.splice(i, 1);
      });
    },
    removeTypography(i) {
      this.form.typographies.splice(i, 1);
    },

    setDecimalSize(index, name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form.sizes.$each.$iter[index][name].$model = val;
      this.$v.form.sizes.$each.$iter[index][name].$touch();
    },

    setDecimalTypographySize(indexTypography, indexSize, name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form.typographies.$each.$iter[indexTypography].sizes.$each.$iter[
        indexSize
      ][name].$model = val;
      this.$v.form.typographies.$each.$iter[indexTypography].sizes.$each.$iter[
        indexSize
      ][name].$touch();
    },

    validateStateSize(index, name) {
      const { $dirty, $error } = this.$v.form.sizes.$each.$iter[index][name];
      return $dirty ? !$error : null;
    },
    validateStateTypography(index, name) {
      const { $dirty, $error } = this.$v.form.typographies.$each.$iter[index][
        name
      ];
      return $dirty ? !$error : null;
    },
    validateStateTypographySize(indexTypography, indexSize, name) {
      const { $dirty, $error } = this.$v.form.typographies.$each.$iter[
        indexTypography
      ].sizes.$each.$iter[indexSize][name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      this.$v.$reset();

      store.setOverlayShow(true);

      let data = {};

      data.sizes = this.form.sizes;
      data.typographies = this.form.typographies;

      Sentry.setExtra('data', JSON.stringify(data));

      actions
        .postInitial(data)
        .then((x) => {
          store.setOverlayShow(false);

          this.form.success = {
            show: true,
            text: 'Información guardada satisfactoriamente',
          };
        })
        .catch((y) => {
          store.setOverlayShow(false);

          this.form.error = {
            show: true,
            text: 'Ha ocurrido un error inesperado',
          };
          console.error(y);
        });
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
